import { AppSettings } from '../constants';
import Jwt, { sendAjaxRequest } from '../helper/interceptors';
import { v4 as uuidv4 } from 'uuid';
import S3 from 'aws-sdk/clients/s3';
import { config, Credentials } from 'aws-sdk/lib/core';
import { ObjToParam, MapResponse } from '../helper/helper-api';
import removeDiacritics from '../helper/remove-diacritics';

export const createPunchList = params => {
  console.log(params, 'createPunchList api params')
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .post('/api/punch-lists', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchPunchList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`/api/reports/punch-lists/search?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updatePunchListManagedBy = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`/api/punch-lists/${params.refNo}/managed-by-users`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getPunchListDetail = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .get(`/api/punch-lists/${params.refNo}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const createPunchListItem = params => {
  console.log(params, 'createPunchList params')
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .post(`/api/punch-lists/${params.refNo}/punch-items`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getPunchListItemDetail = params => {
  const isBuilder = AppSettings.clientTypeValue === 'Builder';
  const vApi = isBuilder ? 'api' : 'apiv1';
  return Jwt(
    isBuilder ? AppSettings.CURRENT_SITE_URI : AppSettings.GLOBAL_API_URL,
    true,
    {
      headers: [{ key: 'Key', value: params.punchListItemRefNo }]
    }
  )
    .get(
      `/${vApi}/punch-lists/${params.punchListRefNo}/punch-items/${
        params.punchListItemRefNo
      }`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updatePunchItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.punchItemRefNo }]
  })
    .put(
      `/api/punch-lists/${params.punchListRefNo}/punch-items/${
        params.punchItemRefNo
      }`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const sendPunchItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.punchItemRefNo }]
  })
    .put(
      `/api/punch-lists/${params.punchListRefNo}/punch-items/${
        params.punchItemRefNo
      }/open`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const sendMultiplePunchItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put(
      `/api/punch-lists/${params.punchListRefNo}/punch-items/open-multiple`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const setupPunchListAWS = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post('/api/aws/s3/credentials', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const uploadPunchListAttachmentToS3 = (params, callback) => {
  config.credentials = new Credentials({
    accessKeyId: params.config.accessKeyId,
    secretAccessKey: params.config.secretAccessKey,
    sessionToken: params.config.sessionToken
  });

  const fileName = removeDiacritics(params.file.name);
  const enFileName = uuidv4() + '.' + fileName.split('.').pop();
  const s3 = new S3({ region: params.config.region });

  const payload = {
    ACL: 'public-read',
    Body: params.file,
    Bucket: params.config.bucket,
    ContentType: params.file.type,
    ContentDisposition: 'inline; filename="' + fileName + '"',
    Key: `${params.config.path}/${enFileName}`
  };
  let upload = s3.upload(payload);

  upload.send((error, data) => {
    if (data) {
      callback(data);
    } else {
      console.log('error', error);
    }
  });
};

export const uploadPunchListAttachmentToServer = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, false, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .post(
      `/apiv1/punch-lists/punch-items/${params.refNo}/attachments`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

// SUBCONTRACTOR
export const getSubcontractorPunchListDetail = params => {
  let url = `/apiv1/punch-lists/${params.refNo}`;

  if (params.tradeId && params.subcontractorId) {
    url = `${url}?tradeId=${params.tradeId}&subcontractorId=${params.subcontractorId}`;
  }

  return Jwt(AppSettings.GLOBAL_API_URL, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .get(url)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const exportPunchListList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, { responseType: 'blob' })
    .get(`/api/reports/export/punch-lists?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response, true);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const exportBlueTapeReport = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, { responseType: "blob" })
    .post(`/api/reports/export/bluetape-report`, params)
    .then(response => {
      return MapResponse(response, true);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchSubcontractorPunchList = params => {
  return Jwt(AppSettings.GLOBAL_API_URL)
    .get(`/apiv1/punch-lists/search?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getLotPaidFeature = () => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`/api/v1/builder/lotpaidfeature/get-builder-lot-feature`)
    .then(response => {
      return MapResponse(response, true);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getEplCustomTerms = () => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get('/api/settings/get-custom-terms')
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const sendBlueTapeEmail = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('/api/reports/send/bluetape-email', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};



// WEBPACK FOOTER //
// ./src/Punch-List/api.js